import { Logo } from './Logo';

type Props = {
  onRequestAccess: () => void;
};

export function Nav({ onRequestAccess }: Props) {
  return (
    <header className="sticky top-0 z-40 border-b border-border-subtle bg-bg-base/80 backdrop-blur-md">
      <div className="container-page flex h-[70px] items-center justify-between">
        <a href="#top" className="flex items-center" aria-label="Claros home">
          <Logo />
        </a>

        <nav className="flex items-center gap-7">
          <a href="#how" className="hidden text-[14.5px] link-quiet sm:inline">
            How it works
          </a>
          <a href="#sources" className="hidden text-[14.5px] link-quiet sm:inline">
            Sources
          </a>
          <button
            type="button"
            onClick={onRequestAccess}
            className="btn-primary px-4 py-2.5 text-[14px]"
          >
            Request early access
          </button>
        </nav>
      </div>
    </header>
  );
}
